<div class="stock-page-container" *ngIf="selectedMainOption !== 'Stock-History' && !isLoadingLabels && !isLoadingAvailableUsers">
	<div class="main-options-col" [ngClass]="{ selectedMain: selectedMainOption === 'not-chosen' }">
		<span class="title">{{ labels.lbl_status_estoque }}</span>
		<div class="main-option-list">
			<div
				class="option"
				[ngClass]="{ selected: selectedEntry === 'Movement' }"
				(click)="selectedEntry = 'Movement'; selectedMainOption = 'Search'">
				<span><fa-icon [icon]="icons.faPlus"></fa-icon></span>
				<span>{{ labels.lbl_estoque_navigation_movimentacao_emprestimo }}</span>
				<span class="arrow"><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
			</div>

			<div
				class="option"
				[ngClass]="{ selected: selectedEntry === 'Lending' || selectedEntry === 'Return' }"
				(click)="selectedEntry = 'Lending'; selectedMainOption = 'Search'; clearLendingPage()">
				<span><fa-icon [icon]="icons.faTentArrowTurnLeft"></fa-icon></span>
				<span>{{ labels.lbl_geral_devolucao }}</span>
				<span class="arrow"><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
			</div>

			<div
				class="option"
				[ngClass]="{ selected: selectedEntry === 'Search' }"
				(click)="selectedEntry = 'Search'; selectedMainOption = 'Search'">
				<span><fa-icon [icon]="icons.faList"></fa-icon></span>
				<span>{{ labels.lbl_consultar_estoque }}</span>
				<span class="arrow"><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
			</div>

			<div
				class="option"
				[ngClass]="{ selected: selectedEntry === 'EnduserHistory' }"
				(click)="selectedEntry = 'EnduserHistory'; selectedMainOption = 'Search'">
				<span><fa-icon [icon]="icons.faPerson"></fa-icon></span>
				<span>{{ labels.lbl_geral_usuarios }}</span>
				<span class="arrow"><fa-icon [icon]="icons.faAngleRight"></fa-icon></span>
			</div>
		</div>
	</div>

	<div class="not-chosen-col" *ngIf="selectedMainOption === 'not-chosen'">
		<span><fa-icon [icon]="icons.faBoxOpen"></fa-icon></span>
		<span>{{ labels.lbl_selecione_uma_opcao }}</span>
	</div>

	<div class="stock-col" [ngClass]="{ selectedMain: selectedMainOption === 'Search' }" *ngIf="selectedMainOption === 'Search'">
		<div class="navigation">
			<span (click)="selectedMainOption = 'not-chosen'; selectedEntry = 'not-chosen'">{{ labels.lbl_geral_inicio }}</span>
			<span *ngIf="selectedEntry === 'Movement'"> < {{ labels.lbl_estoque_navigation_movimentacao_emprestimo }}</span>
			<span *ngIf="selectedEntry === 'Lending'"> < {{ labels.lbl_geral_devolucao }}</span>
			<span *ngIf="selectedEntry === 'EnduserHistory'"> < {{ labels.lbl_geral_usuarios }}</span>
			<span *ngIf="selectedEntry === 'EnduserHistory' && userLendings != undefined"> < {{ labels.lbl_geral_emprestimo }}</span>
		</div>

		<pcp-cmdb-search-filter
			[hideFilters]="['customer', 'substatus']"
			[hideItemsFilters]="['maintenance_contract', 'Contrato']"
			(getSelectedCi)="selectCiHistory($event)"
			*ngIf="selectedEntry === 'Movement'">
		</pcp-cmdb-search-filter>

		<div *ngIf="selectedEntry === 'Lending'">
			<div class="card-display">
				<div class="title">{{ labels.lbl_filtros_de_busca }}</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_chamado }}</span>
					<input (input)="request = $event.target.value" placeholder="{{ labels.lbl_geral_inserir }} {{ labels.lbl_chamado }}" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_usuario_responsavel }} *</span>
					<cpi-input-with-autocomplete
						[availableOptions]="availableUsersIAC"
						[cleanValues]="false"
						[minInputLength]="3"
						[placeholder]="labels.lbl_geral_pesquisar_usuario"
						[inputHeight]="'22px'"
						[alert]="alertFields.userResponsible"
						(onValueChange)="selectedUserId = $event"
						*ngIf="!isLoadingAvailableUsers">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_localidade }}</span>
					<cpi-input-with-autocomplete
						[availableOptions]="listLocationsIAC"
						[minInputLength]="0"
						[placeholder]="labels.lbl_geral_location_selecione"
						*ngIf="!isLoadingLocations"
						(onValueChange)="selectedLocationId = $event"
						[cleanValues]="clearValuesLocation">
					</cpi-input-with-autocomplete>
				</div>

				<div class="button-container">
					<div class="button" (click)="getPendingLending()">
						Pesquisar
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isLoadingLendingsButton"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</div>

			<div *ngIf="!isLoadingLendings" class="title mt-2">{{ labels.lbl_devolucao_pendente }} *</div>
			<ng-container *ngIf="!isLoadingLendings">
				<cpi-input-with-autocomplete
					[availableOptions]="iacPendingLending"
					[placeholder]="labels.lbl_geral_selecione"
					[minInputLength]="0"
					[inputHeight]="'30px'"
					(getInputText)="filterPendingLending($event)">
				</cpi-input-with-autocomplete>
			</ng-container>
			<cpi-msp-table
				[labels]="labels"
				[header]="stockPendingLendingMspTableHeader"
				[height]="'40dvh'"
				[body]="filteredPendingLending"
				[insideSort]="true"
				(getSelectedItemIndex)="setReturn($event)"
				*ngIf="filteredPendingLending.length > 0">
			</cpi-msp-table>
		</div>

		<div class="search-user-container" *ngIf="selectedEntry === 'EnduserHistory' && userLendings == undefined">
			<cpi-input-with-autocomplete
				[availableOptions]="availableUsersIAC"
				[minInputLength]="3"
				[placeholder]="labels.lbl_geral_pesquisar_usuario"
				[inputHeight]="'22px'"
				[keepValue]="true"
				(onValueChange)="userLendings = undefined; selectedUserId = $event; selectedUserId ? getUserLendings() : null">
			</cpi-input-with-autocomplete>

			<cpi-msp-table
				[labels]="labels"
				[header]="usersMspTableHeader"
				[body]="availableUsersIAC"
				[height]="'55dvh'"
				[sortDown]="true"
				(getSelectedItem)="stockData.idUserResponsible = $event['value']; alertFields.userResponsible = false"
				(getSort)="sortUserIAC()">
			</cpi-msp-table>

			<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingUserLendings"></cpi-dot-bounce-loading-effect>
		</div>

		<div *ngIf="!isLoadingUserLendings && userLendings != undefined">
			<div class="card-table-container" *ngIf="userLendings.length > 0">
				<div class="card-table-header-container" [ngStyle]="{ 'grid-template-columns': 'repeat(' + 3 + ', 1fr)' }">
					<div
						[ngClass]="{ highlight: userLendingsSort === 'name' }"
						(click)="
							userLendingsSort === 'name' ? (userSortDown = !userSortDown) : null; sortUserLendCardsBy('name', userSortDown)
						">
						{{ labels.lbl_geral_identificacao }}
						<span [ngClass]="{ up: userLendingsSort === 'name' && !userSortDown }"
							><fa-icon [icon]="userLendingsSort !== 'name' || userSortDown ? icons.faSortDown : icons.faSortUp"></fa-icon
						></span>
					</div>
					<div
						[ngClass]="{ highlight: userLendingsSort === 'expectedReturnDate' }"
						(click)="
							userLendingsSort === 'expectedReturnDate' ? (userSortDown = !userSortDown) : null;
							sortUserLendCardsBy('expectedReturnDate', userSortDown)
						">
						{{ labels.lbl_data_prevista_devolucao }}
						<span [ngClass]="{ up: userLendingsSort === 'expectedReturnDate' && !userSortDown }"
							><fa-icon
								[icon]="
									userLendingsSort !== 'expectedReturnDate' || userSortDown ? icons.faSortDown : icons.faSortUp
								"></fa-icon
						></span>
					</div>
					<div
						[ngClass]="{ highlight: userLendingsSort === 'returnDate' }"
						(click)="
							userLendingsSort === 'returnDate' ? (userSortDown = !userSortDown) : null;
							sortUserLendCardsBy('returnDate', userSortDown)
						">
						{{ labels.lbl_geral_data_retorno }}
						<span [ngClass]="{ up: userLendingsSort === 'returnDate' && !userSortDown }"
							><fa-icon
								[icon]="userLendingsSort !== 'returnDate' || userSortDown ? icons.faSortDown : icons.faSortUp"></fa-icon
						></span>
					</div>
				</div>
				<div class="card-table-body-container">
					<a
						class="item-card-table"
						[ngClass]="{ odd: index % 2 == 1 }"
						[ngStyle]="{ 'grid-template-columns': 'repeat(3, 1fr)' }"
						[routerLink]="'/cmdb/ci/' + card.cmdbId"
						*ngFor="let card of userLendings; let index = index">
						<span>{{ card.name }}</span>
						<span>{{ DateService.formatDate(card.expectedReturnDate) }}</span>
						<span>{{ DateService.formatDate(card.returnDate) }}</span>
					</a>
				</div>
			</div>

			<div class="no-card-container" *ngIf="userLendings.length == 0">
				{{ labels.lbl_security_nenhum_registro }}
			</div>

			<div class="button-container">
				<div class="button" (click)="navigateTo('stock/user/' + selectedUserId)">
					{{ labels.lbl_visualizar_mapa_relacionamento }}
				</div>
			</div>
		</div>

		<pcp-cmdb-search-filter
			[hideFilters]="['customer', 'substatus']"
			[hideItemsFilters]="['maintenance_contract', 'Contrato']"
			(getSelectedCi)="selectCiData($event)"
			*ngIf="selectedEntry === 'Search'">
		</pcp-cmdb-search-filter>
	</div>

	<div class="stock-col" [ngClass]="{ selectedMain: selectedMainOption === 'Stock' }" *ngIf="selectedMainOption === 'Stock'">
		<div class="title">
			<span *ngIf="selectedEntry === 'Movement'">{{ labels.lbl_estoque_navigation_movimentacao_emprestimo }}</span>
			<span *ngIf="selectedEntry === 'Lending'">{{ labels.lbl_geral_devolucao }}</span>
		</div>

		<div class="navigation">
			<span (click)="selectedMainOption = 'not-chosen'; selectedEntry = 'not-chosen'"> {{ labels.lbl_geral_home }}</span>
			<span (click)="selectedMainOption = 'Search'"> {{ labels.lbl_geral_busca }}</span>
		</div>

		<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-2)'" *ngIf="isLoadingStocks"></cpi-dot-bounce-loading-effect>
		<ng-container *ngIf="!isLoadingStocks">
			<div *ngIf="selectedEntry === 'Lending' || selectedEntry === 'Movement' || selectedEntry === 'Return'">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_identificacao }}</span>
					<input disabled [value]="stockData.relatedCi.identification" />
				</div>

				<div *ngIf="stockData.relatedCi.isConsumable === true">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_disponiveis }}</span>
						<input
							type="string"
							disabled
							[value]="
								stockData.available +
								(stockData.idTypeMovement === '1'
									? 1
									: stockData.idTypeMovement === '2' ||
										  stockData.idTypeMovement === '3' ||
										  stockData.idTypeMovement === '4' ||
										  stockData.idTypeMovement === '5'
										? -1
										: 0) +
								' <- ' +
								stockList[0].available
							" />
					</div>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_usuario_responsavel }} *</span>
					<cpi-input-with-autocomplete
						[availableOptions]="availableUsersIAC"
						[cleanValues]="stockData.idUserResponsible === '-1' ? true : false"
						[minInputLength]="3"
						[placeholder]="labels.lbl_geral_pesquisar_usuario"
						[inputHeight]="'22px'"
						[alert]="alertFields.userResponsible"
						(onValueChange)="stockData.idUserResponsible = $event; alertFields.userResponsible = false">
					</cpi-input-with-autocomplete>
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_nota_fiscal }}</span>
					<input (input)="stockData.document = $event.target.value" [value]="stockData.document" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_chamado }}</span>
					<input (input)="stockData.request = $event.target.value" [value]="stockData.request" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_localidade }}</span>
					<input disabled [value]="stockData.relatedCi.location" />
				</div>

				<div class="dotted-input-container" *ngIf="stockData.idTypeMovement != '4'">
					<span>{{ labels.lbl_geral_tipo }} *</span>
					<select
						[ngClass]="{ markAlert: alertFields.idTypeMovement }"
						(change)="stockData.idTypeMovement = $event.target.value; alertFields.idTypeMovement = false; resetMovement()">
						<option [value]="'-1'" [selected]="stockData.idTypeMovement === '' || stockData.idTypeMovement === '-1'">
							{{ labels.lbl_geral_selecione }}
						</option>
						<option
							[selected]="stockData.idTypeMovement === '1'"
							[value]="'1'"
							*ngIf="stockData.relatedCi.isConsumable === true || stockData.relatedCi.isConsumable === 1">
							{{ labels.lbl_geral_entrada }}
						</option>
						<option
							[selected]="stockData.idTypeMovement === '2'"
							[value]="'2'"
							*ngIf="stockData.relatedCi.isConsumable === true || stockData.relatedCi.isConsumable === 1">
							{{ labels.lbl_geral_saida }}
						</option>
						<option
							[selected]="stockData.idTypeMovement === '3'"
							[value]="'3'"
							*ngIf="
								stockList[0].available > 0 ||
								stockData.relatedCi.isConsumable === false ||
								stockData.relatedCi.isConsumable === 0
							">
							{{ labels.lbl_stock_emprestimo }}
						</option>
						<option
							[selected]="stockData.idTypeMovement === '5'"
							[value]="'5'"
							*ngIf="
								stockList[0].available > 0 ||
								stockData.relatedCi.isConsumable === false ||
								stockData.relatedCi.isConsumable === 0
							">
							{{ labels.lbl_asset_alocacao }}
						</option>
					</select>
				</div>

				<div class="dotted-input-container" *ngIf="stockData.idTypeMovement === '4'">
					<span>{{ labels.lbl_geral_tipo }}</span>
					<input [value]="labels.lbl_geral_devolucao" disabled />
				</div>

				<ng-container *ngIf="stockData.idTypeMovement === '1'">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_quantidade }}</span>
						<input
							type="number"
							[min]="1"
							oninput="validity.valid || (value = 1)"
							(change)="handleMovement($event.target.value); stockData.in = $event.target.value"
							[value]="stockData.in" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_data_entrada }} *</span>
						<input
							[ngClass]="{ markAlert: alertFields.movementDate }"
							type="date"
							(change)="stockData.movementDate = $event.target.value; alertFields.movementDate = false"
							[value]="today | date: 'yyyy-MM-dd'" />
					</div>
				</ng-container>

				<ng-container *ngIf="stockData.idTypeMovement === '2'">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_quantidade }}</span>
						<input
							type="number"
							[min]="1"
							[max]="stockList[0].available"
							oninput="value <= 1 ? validity.valid || (value = 1) : validity.valid || (value = max)"
							(change)="handleMovement($event.target.value); stockData.out = $event.target.value"
							[value]="stockData.out" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_data_saida }} *</span>
						<input
							[ngClass]="{ markAlert: alertFields.movementDate }"
							type="date"
							(change)="stockData.movementDate = $event.target.value; alertFields.movementDate = false"
							[value]="today | date: 'yyyy-MM-dd'" />
					</div>
				</ng-container>

				<ng-container *ngIf="stockData.idTypeMovement === '3'">
					<div class="dotted-input-container" *ngIf="stockData.relatedCi.isConsumable === true">
						<span>{{ labels.lbl_geral_quantidade }}</span>
						<input
							type="number"
							[min]="1"
							[max]="stockList[0].available"
							oninput="value <= 1 ? validity.valid || (value = 1) : validity.valid || (value = max)"
							(change)="handleMovement($event.target.value); stockData.out = $event.target.value"
							[value]="stockData.out" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_data_emprestimo }} *</span>
						<input
							[ngClass]="{ markAlert: alertFields.movementDate }"
							type="date"
							(change)="stockData.movementDate = $event.target.value; alertFields.movementDate = false"
							[value]="today | date: 'yyyy-MM-dd'" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_data_prevista_devolucao }} *</span>
						<input
							[ngClass]="{ markAlert: alertFields.expectedReturnDate }"
							type="date"
							(change)="stockData.expectedReturnDate = $event.target.value; alertFields.expectedReturnDate = false"
							[value]="today | date: 'yyyy-MM-dd'" />
					</div>
				</ng-container>

				<ng-container *ngIf="stockData.idTypeMovement === '4'">
					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_devolver }}</span>
						<input
							type="number"
							[min]="1"
							[max]="stockList[0].available"
							oninput="value <= 1 ? validity.valid || (value = 1) : validity.valid || (value = max)"
							(change)="handleMovement($event.target.value); stockData.in = $event.target.value"
							[value]="stockData.in" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_return_date }} *</span>
						<input
							[ngClass]="{ markAlert: alertFields.returnDate }"
							type="date"
							(change)="stockData.returnDate = $event.target.value; alertFields.returnDate = false"
							[value]="today | date: 'yyyy-MM-dd'" />
					</div>
				</ng-container>

				<ng-container *ngIf="stockData.idTypeMovement === '5'">
					<div class="dotted-input-container" *ngIf="stockData.relatedCi.isConsumable === true">
						<span>{{ labels.lbl_geral_quantidade }}</span>
						<input
							type="number"
							[min]="1"
							[max]="stockList[0].available"
							oninput="value <= 1 ? validity.valid || (value = 1) : validity.valid || (value = max)"
							(change)="handleMovement($event.target.value); stockData.out = $event.target.value"
							[value]="stockData.out" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_data_emprestimo }} *</span>
						<input
							[ngClass]="{ markAlert: alertFields.movementDate }"
							type="date"
							(change)="stockData.movementDate = $event.target.value; alertFields.movementDate = false"
							[value]="today | date: 'yyyy-MM-dd'" />
					</div>
				</ng-container>

				<div class="label-input">{{ labels.lbl_geral_observacoes }}:</div>
				<textarea [rows]="3" (input)="stockData.observation = $event.target.value" [value]="stockData.observation"> </textarea>
			</div>

			<div class="button-container">
				<div class="button" (click)="openModalEvaluationMSP()">{{ labels.lbl_geral_avaliar }} MySupport</div>
				<div class="button" [ngClass]="{ disabled: isUpdatindStocks }" (click)="updateStock()">
					{{ labels.lbl_geral_inserir }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdatindStocks"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</ng-container>
	</div>

	<div
		class="stock-col"
		[ngClass]="{ selectedMain: selectedMainOption === 'Stock-Display' }"
		*ngIf="selectedMainOption === 'Stock-Display'">
		<div class="title">
			<span *ngIf="selectedEntry === 'Movement'">{{ labels.lbl_estoque_navigation_movimentacao_emprestimo }}</span>
			<span *ngIf="selectedEntry === 'Lending'">{{ labels.lbl_geral_devolucao }}</span>
		</div>

		<div class="navigation">
			<span (click)="selectedMainOption = 'not-chosen'; selectedEntry = 'not-chosen'"> {{ labels.lbl_geral_home }}</span>
			<span (click)="selectedMainOption = 'Search'"> {{ labels.lbl_geral_busca }}</span>
		</div>

		<ng-container *ngIf="!isLoadingStocks">
			<div class="card-display">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_identificacao }}:</span>
					<span>{{ stockData.relatedCi.identification }}</span>
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_disponiveis }}:</span>
					<span>{{ stockData.available }}</span>
				</div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_ultima_atualizacao }}:</span>
					<span>{{ stockData.createdAt }}</span>
				</div>
				<div class="button-container" *ngIf="stockData.movementDate !== '' && stockData.movementDate !== 'N/A'">
					<div class="button" (click)="getStockHistory()">{{ labels.lbl_see_more }}</div>
				</div>
			</div>
		</ng-container>

		<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingStocks"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<div
	class="stock-page-container"
	[ngClass]="{
		selectedMain: selectedMainOption === 'Stock-History' && !isLoadingLabels && !isLoadingAvailableUsers && !isLoadingLendings,
	}"
	*ngIf="selectedMainOption === 'Stock-History' && !isLoadingLabels && !isLoadingAvailableUsers && !isLoadingLendings">
	<div class="stock-history-container">
		<div class="header">
			<div class="navigation">
				<span (click)="selectedMainOption = 'not-chosen'; selectedEntry = 'not-chosen'"> {{ labels.lbl_geral_home }}</span>
				<span *ngIf="!isLoadingStocks">
					{{ labels.lbl_stock_historico_do }} {{ stockList[0].relatedCi.identification }} ({{
						stockList[0].relatedCi.location
					}})</span
				>
			</div>
		</div>

		<div class="body">
			<div class="history-grid" *ngIf="!isLoadingStocks">
				<span>{{ labels.lbl_data_mov }}</span>
				<span>{{ labels.lbl_geral_tipo }}</span>
				<span>{{ labels.lbl_usuario_responsavel }}</span>
				<span>{{ labels.lbl_geral_entrada }}</span>
				<span>{{ labels.lbl_geral_saida }}</span>
				<span>{{ labels.lbl_geral_disponiveis }}</span>
				<span>{{ labels.lbl_geral_nota_fiscal }}</span>
				<span>{{ labels.lbl_chamado }}</span>
				<span>{{ labels.lbl_geral_observacoes }}</span>
				<ng-container *ngFor="let stockItem of stockList">
					<input [class]="stockItem.typeMovement" [title]="stockItem.createdAt" [value]="stockItem.createdAt" readonly />
					<input
						[class]="stockItem.typeMovement"
						[title]="labels[stockItem.typeMovementLabel] ? labels[stockItem.typeMovementLabel] : stockItem.typeMovementLabel"
						[value]="labels[stockItem.typeMovementLabel] ? labels[stockItem.typeMovementLabel] : stockItem.typeMovementLabel"
						readonly />
					<input
						[class]="stockItem.typeMovement"
						[title]="stockItem.userResponsible"
						[value]="stockItem.userResponsible"
						readonly />
					<input
						[class]="stockItem.typeMovement"
						[title]="stockItem.idTypeMovement === 1 || stockItem.idTypeMovement === 4 ? stockItem.in : 0"
						[value]="stockItem.idTypeMovement === 1 || stockItem.idTypeMovement === 4 ? stockItem.in : 0"
						readonly />
					<input
						[class]="stockItem.typeMovement"
						[title]="stockItem.idTypeMovement === 2 || stockItem.idTypeMovement === 3 ? stockItem.out : 0"
						[value]="stockItem.idTypeMovement === 2 || stockItem.idTypeMovement === 3 ? stockItem.out : 0"
						readonly />
					<input [class]="stockItem.typeMovement" [title]="stockItem.available" [value]="stockItem.available" readonly />
					<input [class]="stockItem.typeMovement" [title]="stockItem.document" [value]="stockItem.document" readonly />
					<input [class]="stockItem.typeMovement" [title]="stockItem.request" [value]="stockItem.request" readonly />
					<input
						[class]="stockItem.typeMovement"
						[title]="stockItem.observation"
						[value]="stockItem.observation"
						(click)="notifyText(stockItem.observation)"
						readonly />
				</ng-container>
			</div>

			<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingStocks"></cpi-dot-bounce-loading-effect>
		</div>
	</div>
</div>

<div
	class="evaluation-msp-modal evaluation-msp-modal-extremity-close"
	id="modalClose"
	(click)="modalClose($event, false)"
	*ngIf="isOpenModalEvaluationMSP">
	<div class="evaluation-msp-modal-content">
		<span class="evaluation-msp-modal-close" (click)="modalClose($event, true)"><fa-icon [icon]="icons.faXmark"></fa-icon></span>
		<app-mysupport-evaluation></app-mysupport-evaluation>
	</div>
</div>

<div
	class="loading-container"
	[ngClass]="{ selectedMain: isLoadingLabels || isLoadingAvailableUsers || isLoadingLendings }"
	*ngIf="isLoadingLabels || isLoadingAvailableUsers || isLoadingLendings">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
